import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading, petitionSlugCanonicalRedirect, starter } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'petition-activity',
		path: '/p/:slug/activity',
		component: loadable(async () => import(/* webpackChunkName: "pages/petition_activity" */ './index'), {
			exportName: 'PetitionActivity',
			fallback: Loading,
		}),
		beforeServerRender: async (context) => {
			await petitionSlugCanonicalRedirect(context);
		},
		frame: true,
		restrictedAccess: {
			authOnly: true,
			role: ['staff', starter('slug')],
		},
		ssr: {
			enabled: true,
			seo: false,
		},
	},
];
